angular.module("app").component("contactUsComponent", {
  templateUrl: "app/components/contact-us/contact-us.tmpl.html",
  controller: function ($http, appConfig) {
    const self = this;

    self.topics = [
      { id: "general", label: "General question", endpoint: "contact_us" },
      { id: "partnership", label: "Partnership or data", endpoint: "data_partner" },
      { id: "schools", label: "Schools and teams", endpoint: "contact_us" },
      { id: "press", label: "Press", endpoint: "press" },
      { id: "support", label: "Help with my account", endpoint: "contact_us" },
    ];
    self.sizes = ["1-10", "11-50", "51-200", "201-500", "501-1,000", "1,001-5,000", "5,000+"];
    self.industries = [
      "Activewear", "Agency", "Auto", "Beauty", "Big box retail", "Consumer electronics", "CPG / FMCG",
      "Department stores", "Education", "Fashion", "Financial services", "Food and beverage", "Hospitality",
      "Real estate", "Restaurants", "Specialty retail", "Technology", "Watches and jewelry", "Other",
    ];

    const blank = () => ({ topic: "general", first_name: "", last_name: "", email: "", company: "", title: "", company_size: null, industry: null, body: "" });
    self.f = blank();
    self.bad = {};
    self.error = "";
    self.busy = false;
    self.sent = false;

    self.placeholder = () => ({
      partnership: "What data or collaboration do you have in mind?",
      schools: "How many students or seats, and for which course or team?",
      press: "Your outlet, your deadline, and what you're working on.",
      support: "What happened, and the email on your Huedata account.",
    }[self.f.topic] || "How can we help?");

    const emailOk = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e || "");

    self.submit = () => {
      const f = self.f;
      self.bad = {
        first_name: !f.first_name.trim(),
        last_name: !f.last_name.trim(),
        email: !emailOk(f.email),
        company: f.topic === "partnership" && !f.company.trim(),
        body: !f.body.trim(),
      };
      if (Object.values(self.bad).some(Boolean)) {
        self.error = self.bad.email && f.email ? "That email address doesn't look right." : "Please fill in the highlighted fields.";
        return;
      }
      self.error = "";
      self.busy = true;

      const topic = self.topics.find((t) => t.id === f.topic);
      // The contact table has no topic column, and the API drops company_size
      // and industry, so they travel at the top of the message instead.
      const extra = [
        topic.id === "general" ? "" : `Topic: ${topic.label}`,
        f.company_size ? `Company size: ${f.company_size}` : "",
        f.industry ? `Industry: ${f.industry}` : "",
      ].filter(Boolean).join("\n");
      const contact = {
        first_name: f.first_name.trim(),
        last_name: f.last_name.trim(),
        email: f.email.trim(),
        company: f.company.trim(),
        title: f.title.trim(),
        body: extra ? `${extra}\n\n${f.body.trim()}` : f.body.trim(),
      };

      $http
        .post(appConfig.dashboardServiceUrl + `api/forms/${topic.endpoint}.json`, { contact })
        .then((res) => {
          self.busy = false;
          if (res.status === 201 || res.status === 200) {
            self.sentName = contact.first_name;
            self.sentEmail = contact.email;
            self.sent = true;
          } else {
            self.error = "Something went wrong. Please try again, or email hello@huedata.ai.";
          }
        })
        .catch(() => {
          self.busy = false;
          self.error = "Something went wrong. Please try again, or email hello@huedata.ai.";
        });
    };

    self.again = () => {
      self.f = blank();
      self.bad = {};
      self.sent = false;
    };
  },
});
